// Blog registry — generated from blog.xlsx.
// Metadata is eagerly loaded; Content components are lazy-loaded per blog.
import { lazy } from 'react';
import allPosts from './posts.json';
import { livePosts } from './schedule.js';

// Only posts whose date has arrived (see schedule.js). __PUBLISH_DAY__ and
// __SHOW_SCHEDULED__ are set in vite.config.js at build time.
const postsData = livePosts(allPosts, __PUBLISH_DAY__, { showScheduled: __SHOW_SCHEDULED__ });

// Vite glob: maps slug -> dynamic import for that blog's Content
const modules = import.meta.glob('./[0-9]*.jsx');

const slugToImporter = {};
for (const path in modules) {
  const file = path.replace('./', '').replace('.jsx', '');
  slugToImporter[file] = modules[path];
}

export const POSTS = postsData.map((p) => ({
  ...p,
  Content: lazy(() => slugToImporter[p.file]() )
}));

export const getPostBySlug = (slug) => POSTS.find((p) => p.slug === slug);

export const getAdjacent = (slug) => {
  const i = POSTS.findIndex((p) => p.slug === slug);
  if (i < 0) return { prev: null, next: null };
  return {
    prev: i > 0 ? POSTS[i - 1] : null,
    next: i < POSTS.length - 1 ? POSTS[i + 1] : null
  };
};

export const getRelatedPosts = (slug, limit = 3) => {
  const current = getPostBySlug(slug);
  if (!current) return [];
  const sameCat = POSTS.filter((p) => p.slug !== slug && p.category === current.category);
  if (sameCat.length >= limit) return sameCat.slice(0, limit);
  const fallback = POSTS.filter((p) => p.slug !== slug && !sameCat.includes(p));
  return [...sameCat, ...fallback].slice(0, limit);
};
